@if (!isEditingButton()) {
    <web-widget-breadcrumbs [widget]="widget()" [isInSpecificSection]="isSpecific()" />

    <div class="panel-options-body overflow-wrapper">
        <div class="form">
            <p class="text-muted">{{ "edu_widget_title" | translate }}</p>
            <div class="form-group row mb-20">
                <div class="col-xs-12">
                    <label>
                        {{ "control_fields_appearance" | translate }}
                    </label>
                    <a class="dotted pull-right" (click)="setCurrentSettingsType(settingEnum.INPUT)">
                        {{ "control_form_fields_styles" | translate }}
                    </a>
                </div>
                <div class="col-xs-12">
                    <div class="appearance-wrapper">
                        <div
                            class="appearance-block"
                            [class.active]="isStaticFormView()"
                            [tooltip]="staticForm"
                            (click)="form.setFormView(ELoginEduView.static)"
                        >
                            <img src="./assets/img/websites/lpc-static-form-icon.svg" alt="static form" />
                            <div class="appearance-block-label">
                                {{ "embedded_form" | translate }}
                            </div>
                            <ng-template #staticForm>
                                {{ "control_static_form_tooltip" | translate }}
                            </ng-template>
                        </div>
                        <div
                            class="appearance-block"
                            [class.active]="isModalFormView()"
                            [tooltip]="modalForm"
                            (click)="form.setFormView(ELoginEduView.modal)"
                        >
                            <img src="./assets/img/websites/lpc-modal-form-icon.svg" alt="modal form" />
                            <div class="appearance-block-label">
                                {{ "popup_form" | translate }}
                            </div>
                            <ng-template #modalForm>
                                {{ "control_modal_form_tooltip" | translate }}
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
            @if (!isForNewUser()) {
                @if (isStaticFormView()) {
                    <div class="form-group row mb-20">
                        <div class="col-xs-12">
                            <label>{{ "default_form" | translate }}</label>
                        </div>
                        <div class="col-xs-12">
                            <div class="appearance-wrapper mb-5">
                                <div
                                    class="appearance-block"
                                    [class.active]="isDefaultRegisterForm()"
                                    [tooltip]="signUpForm"
                                    (click)="setDefaultForm(ELoginEduDefaultForm.register)"
                                >
                                    <img src="./assets/img/websites/lpc-sign-up-form-icon.svg" alt="sign up form" />
                                    <div class="appearance-block-label">{{ "control_registration" | translate }}</div>
                                    <ng-template #signUpForm>
                                        {{ "edu_widget_sign_up_form_tooltip" | translate }}
                                    </ng-template>
                                </div>
                                <div
                                    class="appearance-block"
                                    [class.active]="isDefaultLoginForm()"
                                    [tooltip]="signInForm"
                                    (click)="setDefaultForm(ELoginEduDefaultForm.login)"
                                >
                                    <img src="./assets/img/websites/lpc-sign-in-form-icon.svg" alt="sign in form" />
                                    <div class="appearance-block-label">{{ "control_authorization" | translate }}</div>
                                    <ng-template #signInForm>
                                        {{ "edu_widget_sign_in_form_tooltip" | translate }}
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 mt-5">
                            <label class="checkbox-inline">
                                <input type="checkbox" [checked]="isBothViewForm()" (change)="toggleEnabledForm()" />
                                @if (isDefaultRegisterForm()) {
                                    <span>
                                        {{ "add_login_label" | translate }}
                                    </span>
                                }
                                @if (isDefaultLoginForm()) {
                                    <span>
                                        {{ "add_signup_label" | translate }}
                                    </span>
                                }
                            </label>
                        </div>
                    </div>
                }
                @if (isModalFormView()) {
                    <div class="form-group row mb-20">
                        <div class="col-xs-12">
                            <label>{{ "control_buttons_display" | translate }}</label>
                        </div>
                        <div class="col-xs-12">
                            <sp-control-handle
                                [controlHandleCheckbox]="true"
                                [controlHandleCheckboxChecked]="!!registrationTrigger()?.isActive"
                                [controlHandleMainText]="registrationTrigger()?.label"
                                [controlHandleSubText]="'control_show_registration_form' | translate"
                                [controlHandleDisableCheckbox]="!authorizationTrigger()?.isActive"
                                (toggleCheckBoxEvent)="toggleRegistrationModalTrigger($event)"
                                (editActionEvent)="editRegistrationModalTrigger()"
                            />
                            <sp-control-handle
                                [controlHandleCheckbox]="true"
                                [controlHandleCheckboxChecked]="!!authorizationTrigger()?.isActive"
                                [controlHandleMainText]="authorizationTrigger()?.label"
                                [controlHandleDisableCheckbox]="!registrationTrigger()?.isActive"
                                [controlHandleSubText]="'control_show_authorization_form' | translate"
                                (toggleCheckBoxEvent)="toggleAuthorizationModalTrigger($event)"
                                (editActionEvent)="editAuthorizationModalTrigger()"
                            />
                        </div>
                        @if (authorizationTrigger()?.isActive && registrationTrigger()?.isActive) {
                            <div class="col-xs-12 mt-5">
                                <label class="checkbox-inline">
                                    <input
                                        type="checkbox"
                                        [checked]="form.linkBetweenForms().value()"
                                        (change)="toggleLinkBetweenForms(!form.linkBetweenForms().value())"
                                    />
                                    <span>{{ "control_link_between_forms" | translate }}</span>
                                </label>
                            </div>
                        }
                    </div>
                }
            }
            @if (isForNewUser() && isModalFormView()) {
                <div class="form-group row mb-20">
                    <div class="col-xs-12">
                        <label>{{ "control_popup_form_button" | translate }}</label>
                    </div>
                    <div class="col-xs-12">
                        <sp-control-handle
                            [controlHandleMainText]="registrationTrigger()?.label"
                            (editActionEvent)="editRegistrationModalTrigger()"
                        />
                    </div>
                </div>
            }
            <hr class="panel-options-divider" />
            @if (showCourseTariffSelector()) {
                <div class="form-group mb-20" [class.has-error]="!form.course().value()">
                    <web-course-tariff-selector
                        [selectedCourse]="form.course().value()?.id"
                        [selectedTariffId]="form.courseTariffId().value()"
                        [isDisabled]="(eduCoursesStatuses$ | async).isNotReady"
                        [showError]="!form.course().value()"
                        [paid]="'all'"
                        [tooltipText]="isLoginViewForm() ? 'login_form_course_selector_tooltip' : ''"
                        [loginEduEnabledForm]="loginEduEnabledForm()"
                        (selectionChange)="handleCourseTariffSelection($event)"
                    />
                </div>
                <hr class="panel-options-divider" />
            }
            <div class="form-group mb-0">
                <label>
                    {{ "control_form_fields" | translate }}
                </label>
            </div>
            @if (!isForNewUser()) {
                <ul class="nav form-type-tabs">
                    <li
                        role="presentation"
                        [class.active]="isDefaultRegisterForm()"
                        [class.disabled]="isRegistrationFormFieldsDisabled()"
                    >
                        <a (click)="setDefaultForm(ELoginEduDefaultForm.register)">
                            <span [innerHTML]="getIcon(ELoginEduDefaultForm.register)" class="icon"></span>
                            <span>{{ "control_registration" | translate }}</span>
                        </a>
                    </li>
                    <li
                        role="presentation"
                        [class.active]="isDefaultLoginForm()"
                        [class.disabled]="isAuthorizationFormFieldsDisabled()"
                    >
                        <a (click)="setDefaultForm(ELoginEduDefaultForm.login)">
                            <span [innerHTML]="getIcon(ELoginEduDefaultForm.login)" class="icon"></span>
                            <span>{{ "control_authorization" | translate }}</span>
                        </a>
                    </li>
                </ul>
            }
            @if (isDefaultRegisterForm()) {
                <div
                    class="mb-20"
                    cdkDropList
                    [cdkDropListData]="form.signUpElements().value()"
                    (cdkDropListDropped)="dropElementItem($event)"
                >
                    @for (input of form.signUpElements().value(); track $index; let i = $index) {
                        <div cdkDrag cdkDropListGroup [cdkDragData]="input">
                            <sp-control-handle
                                [controlHandleBtn]="form.signUpElements().value().length !== 1"
                                [controlHandleDisableDelete]="isDisabledDelete(input)"
                                [controlHandleIcon]="getControlHandleIcon(input.type)"
                                [controlHandleMainText]="input.label | spHtmlToText"
                                (removeActionEvent)="removeInput(i, 'signUp')"
                                (editActionEvent)="editInput(i, 'signUp')"
                            >
                                <span cdkDragHandle></span>
                                <ng-template #variablesTemplate>
                                    <sp-variables-popover
                                        [element]="$any(input)"
                                        [hideEmptyDealVariableAlert]="true"
                                        [crmContactsVariablesList]="crmContacts()"
                                    />
                                </ng-template>
                            </sp-control-handle>
                        </div>
                    }
                    <a class="dotted" (click)="addInput()">{{ "add_field" | translate }}</a>
                </div>
            }
            @if (isDefaultLoginForm()) {
                <div class="mb-20">
                    @for (input of form.signInElements().value(); let i = $index; track $index) {
                        <div>
                            <sp-control-handle
                                [controlHandleBtn]="form.signInElements().value().length !== 1"
                                [controlHandleDisableDelete]="isDisabledDelete(input)"
                                [controlHandleIcon]="getControlHandleIcon(input.type)"
                                [controlHandleMainText]="input.label | spHtmlToText"
                                (removeActionEvent)="removeInput(i, 'signIn')"
                                (editActionEvent)="editInput(i, 'signIn')"
                            />
                        </div>
                    }
                </div>
            }
            @if (showAuthorizationButtonSettings() && authorizationButton(); as authButton) {
                <div class="form-group">
                    <label>
                        {{ "control_authorization_button" | translate }}
                    </label>
                    <sp-control-handle
                        [controlHandleDisableDeleteTooltip]="getDisabledButtonTooltip(authButton)"
                        [controlHandleDisableDelete]="!isDefaultButtonType(authButton)"
                        [controlHandleMainText]="getButtonLabel(authButton)"
                        [controlHandleSubTextWarning]="getButtonWarningColorText(authButton)"
                        (editActionEvent)="editButton(authorizationButtonIndex())"
                    />
                </div>
            }
            @if (showRegistrationButtonSettings() && signUpButton(); as regButton) {
                @if (isForNewUser()) {
                    <label>
                        {{ "form_button" | translate }}
                    </label>
                } @else {
                    <label>
                        {{ "control_registration_button" | translate }}
                    </label>
                }
                <sp-control-handle
                    [controlHandleDisableDeleteTooltip]="getDisabledButtonTooltip(regButton)"
                    [controlHandleDisableDelete]="!isDefaultButtonType(regButton)"
                    [controlHandleMainText]="getButtonLabel(regButton)"
                    [controlHandleSubTextWarning]="getButtonWarningColorText(regButton)"
                    (editActionEvent)="editButton(signUpButtonIndex())"
                />
            }
            @if (showAdditionalButtons()) {
                <hr class="panel-options-divider" />
                <div class="mb-20">
                    @for (button of form.buttons().value(); track $index; let i = $index) {
                        @if (isDefaultButtonType(button)) {
                            <div>
                                <sp-control-handle
                                    [controlHandleDisableDeleteTooltip]="getDisabledButtonTooltip(button)"
                                    [controlHandleDisableDelete]="!isDefaultButtonType(button)"
                                    [controlHandleMainText]="getButtonLabel(button)"
                                    [controlHandleSubText]="getButtonSubText(button)"
                                    [controlHandleSubTextWarning]="getButtonWarningColorText(button)"
                                    (editActionEvent)="editButton(i)"
                                    (removeActionEvent)="removeButton(i, button)"
                                />
                            </div>
                        }
                    }
                    @if (isModalFormView()) {
                        <a class="dotted" (click)="addButton()">
                            {{ "add_button" | translate }}
                        </a>
                    }
                </div>
            }

            @if (showCheckboxRegistrationSettings()) {
                <div class="mb-20">
                    <div class="form-group form-horizontal row">
                        <label class="control-label col-xs-9">
                            {{ "control_checkbox_registration" | translate }}
                            <span
                                class="small sp-icon icon-question color-light hover-effect"
                                [tooltip]="checkbox"
                                triggers="mouseover:mouseleave"
                            ></span>
                            <ng-template #checkbox>
                                {{ "control_checkbox_tooltip" | translate }}
                            </ng-template>
                        </label>
                        <div class="col-xs-3 control-switch text-right">
                            <sp-switch
                                [active]="form.registrationCheckbox().value()"
                                (toggleActiveEvent)="form.setRegistrationCheckbox($event)"
                            />
                        </div>
                    </div>
                </div>
            }
            @if (form.registrationCheckbox().value() && hasRegistrationForm()) {
                <div
                    class="mb-20"
                    cdkDropList
                    [cdkDropListData]="form.checkboxes().value()"
                    (cdkDropListDropped)="dropCheckboxGroup($event)"
                >
                    @for (checkbox of form.checkboxes().value(); track $index; let i = $index) {
                        <div cdkDrag cdkDropListGroup [cdkDragData]="checkbox">
                            <sp-control-handle
                                [controlHandleBtn]="form.checkboxes().value().length !== 1"
                                [controlHandleDisableDelete]="form.checkboxes().value().length === 1"
                                [controlHandleMainText]="checkbox.label | spHtmlToText"
                                (editActionEvent)="editCheckbox(i)"
                                (removeActionEvent)="removeCheckbox(i)"
                                [controlHandleIcon]="getControlIcon"
                            />
                        </div>
                    }
                    <a class="dotted" (click)="addCheckbox()">
                        {{ "add" | translate }}
                    </a>
                </div>
            }
            <div class="form mt-20 mb-20 form-horizontal">
                @if (isZero) {
                    <sp-extended-position-signal-settings
                        [position]="zeroPosition()"
                        [isMobile]="isDeviceMobileSig()"
                        [isTablet]="isDeviceTabletSig()"
                        [showHeight]="false"
                        [parentId]="widget().columnId"
                        (valueChangeEvent)="zeroForm.setPosition($event)"
                    />
                } @else {
                    <web-widget-position-settings
                        [isSynchronized]="true"
                        [isMobile]="isDeviceMobile$ | async"
                        [widgetId]="widget().id"
                        [columnId]="widget().columnId"
                        [position]="form.position().value()"
                        (positionChange)="setPosition($event)"
                    />
                }
            </div>
            <hr class="panel-options-divider" />
            <div class="form mt-20 mb-20 form-horizontal">
                @if (isZero) {
                    <web-widget-extended-hide-settings
                        [hideOnDesktop]="form.hideOnDesktop().value()"
                        [hideOnTablet]="form.hideOnTablet().value()"
                        [hideOnMobile]="form.hideOnMobile().value()"
                        (hideOnDesktopChange)="setHideOnDesktop($event)"
                        (hideOnTabletChange)="setHideOnTablet($event)"
                        (hideOnMobileChange)="setHideOnMobile($event)"
                    />
                } @else {
                    <web-widget-hide-settings
                        [hideOnDesktop]="form.hideOnDesktop().value()"
                        [hideOnTablet]="form.hideOnTablet().value()"
                        [hideOnMobile]="form.hideOnMobile().value()"
                        (hideOnDesktopChange)="setHideOnDesktop($event)"
                        (hideOnTabletChange)="setHideOnTablet($event)"
                        (hideOnMobileChange)="setHideOnMobile($event)"
                    />
                }
            </div>
            <hr class="panel-options-divider" />
            <div class="form-horizontal form-row mb-20">
                <div class="form-group">
                    <label class="control-label col-xs-7">
                        {{ "control_position" | translate }}
                    </label>
                    <div class="col-xs-5">
                        <sp-radio-group
                            [selected]="form.horizontalPosition().value()"
                            [type]="radioGroupType.horizontalPosition"
                            (changeSelectedEvent)="setHorizontalPosition($event)"
                        />
                    </div>
                </div>
            </div>
            <div>
                <a class="dotted" (click)="setCurrentSettingsType(settingEnum.ANALYTICS)">
                    {{ "analytics_form_settings" | translate }}
                </a>
            </div>
            <div class="mt-20">
                <web-custom-id [displayId]="form.displayId()" (valueChangeEvent)="updateWidgetDisplayId($event)" />
            </div>
        </div>
    </div>
} @else {
    @switch (currentSettings()) {
        @case (settingEnum.ELEMENT) {
            <web-field-element-settings
                [form]="form"
                [index]="editedInputIndex() ?? 0"
                [formType]="editedInputType() ?? 'signUp'"
                [crmContactsVariablesList]="crmContacts()"
                [isMainField]="editedInputIndex() === 0"
                [isFileTypeDisabled]="true"
                (saveEvent)="closeSettings(true)"
                (cancelEvent)="closeSettings(false)"
            />
        }
        @case (settingEnum.INPUT) {
            <web-form-input-settings
                [form]="form"
                (saveEvent)="closeSettings(true)"
                (cancelEvent)="closeSettings(false)"
            />
        }
        @case (settingEnum.DEFAULT_BUTTON) {
            <web-default-button-settings
                [form]="form"
                [index]="editableButtonIndex() ?? 0"
                (saveEvent)="closeSettings(true)"
                (cancelEvent)="closeSettings(false)"
            />
        }
        @case (settingEnum.AUTHORIZATION_BUTTON) {
            <web-authorization-button-settings
                [form]="form"
                [index]="editableButtonIndex() ?? 0"
                (saveEvent)="closeSettings(true)"
                (cancelEvent)="closeSettings(false)"
            />
        }
        @case (settingEnum.REGISTRATION_BUTTON) {
            <web-registration-button-settings
                [form]="form"
                [index]="editableButtonIndex() ?? 0"
                (saveEvent)="closeSettings(true)"
                (cancelEvent)="closeSettings(false)"
            />
        }
        @case (settingEnum.CHECKBOX) {
            <web-checkbox-button-settings
                [form]="form"
                [index]="editableCheckboxIndex() ?? 0"
                [crmContactsVariablesList]="crmContacts()"
                (saveEvent)="closeSettings(true)"
                (cancelEvent)="closeSettings(false)"
            />
        }
        @case (settingEnum.ANALYTICS) {
            <web-analytics-settings-signal-legacy
                [settings]="form.analyticsSettings().value()"
                [pixelAnalyticType]="EPixelTypes.completeRegistration"
                (valueChangeEvent)="onAnalyticsSettingsChange($event)"
                (cancelEvent)="closeSettings(false)"
            />
        }
        @case (settingEnum.ADDITIONAL) {
            <web-login-additional-settings
                [form]="form"
                (saveEvent)="closeSettings(true)"
                (cancelEvent)="closeSettings(false)"
            />
        }
        @case (settingEnum.REGISTRATION_TRIGGER) {
            <web-registration-trigger-settings
                [form]="form"
                [index]="signUpButtonIndex()"
                [isForNewUser]="isForNewUser()"
                (saveEvent)="closeSettings(true)"
                (cancelEvent)="closeSettings(false)"
            />
        }
        @case (settingEnum.AUTHORIZATION_TRIGGER) {
            <web-authorization-trigger-settings
                [form]="form"
                [index]="authorizationButtonIndex()"
                (saveEvent)="closeSettings(true)"
                (cancelEvent)="closeSettings(false)"
            />
        }
    }
}
